import { canPlayFullOrPreview } from './video-access';
import { isExternalVideo } from '../../common/ui-selectors/video/video-origin';
export const shouldFetchUrls = ({ videoUrls, channelData = {}, videoItem = {}, currentSiteUser, }) => !videoUrls &&
    !isExternalVideo(videoItem) &&
    canPlayFullOrPreview(channelData, videoItem, currentSiteUser);
//# sourceMappingURL=fetch-urls.js.map